import { ResetCoreqSectionsMetasourceCommand } from '../../../../search_and_add_courses/commands/reset_coreq_sections_metasource_command';
import { CourseDetailsModel } from '../../models/course_details_model';
import { TermProgramInfoModel } from '../../../term_courses/models/term_program_info_model';
import { ISection, ITermCourse, ICrossCourseCorequisite } from '../../../../interfaces/scheduler_interfaces';
import { SectionInfoServant, IFormattedSectionTime } from '../../../sections/servants/section_info_servant';
import { ICommand, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { RegistrationAlertsServant } from '../../../course_scheduler/servants/registration_alerts_servant';
import { ISectionsDatasource } from '../../../sections/datasources/sections_datasource';
import { CrossCourseLinkedSectionsModel } from '../../../../components/section_corequisite/models/cross_course_linked_sections_model';
import { SectionAddCoreqButtonStrategy } from '../../../../components/section_corequisite/strategies/section_coreq_strategy';
import { SectionRequisites } from '../../../course_scheduler/types/requisite_enum';
import { ScheduledSectionStatus } from '../../../course_scheduler/types/scheduled_section_status_enum';
import { ScheduleSectionFacade } from '../../../registration/facades/schedule_section_facade';
import { ClearCrossCourseLinkedSectionsCommand } from '../../../../components/section_corequisite/commands/clear_cross_course_linked_sections_command';
import { CourseDetailsFacade } from '../../facades/course_details_facade';
import { CourseDetailsQuery } from '../../queries/course_details_query';

class CoRequisiteLink {
  private coreq: ICrossCourseCorequisite;
  private course: ITermCourse;
  private term: any;
  private isPlanned: boolean = false;
  private isRegistered: boolean = false;
  private canInteract: boolean = true;
  private type: string = '';
  private coreqStatus: string = '';
  private singleCoreqCrn: string;
  private sectionId: number;
  private addCourseButtonConfig: {
    title: string;
    disabled: boolean;
    hide: boolean;
  };
  private tomFn: () => void;
  constructor(
    private ngTermProgramInfoModel: TermProgramInfoModel,
    private getTermCoursesCommand: ICommand,
    private saveCoReqCourseToTermCommand: ICommand,
    private ngCourseDetailsFacade: CourseDetailsFacade,
    private clearCrossCourseLinkedSectionsCommand: ClearCrossCourseLinkedSectionsCommand,
    private resetCoreqSectionsMetasourceCommand: ResetCoreqSectionsMetasourceCommand,
    private QueryMediator: IQueryMediator,
    private ngCourseDetailsModel: CourseDetailsModel,
    private ngComponentCommunicatorService: CommunicatorService,
    private ngScheduleSectionFacade: ScheduleSectionFacade,
    private $state: ng.ui.IStateService,
    private updateSeatAvailabilityCommand: ICommand,
    private ngCrossCourseLinkedSectionsModel: CrossCourseLinkedSectionsModel,
    private getCourseSchedulerCommand: ICommand,
    private getCrossCourseLinkedSectionsCommand: ICommand,
    private getTermCoursesandScheduledSectionsCommand: ICommand,
    private ngSectionsDatasource: ISectionsDatasource,
    private ngRegistrationAlertsServant: RegistrationAlertsServant,
    private appConfigModel: any,
    private ngCourseDetailsQuery: CourseDetailsQuery
  ) {}

  initialize() {
    const termInfo: any = this.ngTermProgramInfoModel.read();
    this.term = termInfo.term;
    this.configureAddCourseButton();
    this.singleCoreqCrn = !_4.isUndefined(this.coreq.sections) ? this.getCoreqCRN() : '';
    this.isRegistered = this.coreqStatus === ScheduledSectionStatus.REGISTERED;
    this.canInteract = !this.isPlanned && !this.isRegistered;
  }

  $onInit() {
    this.initialize();
  }

  getCoreqCRN() {
    const sectionLabelPrefix = this.appConfigModel.model.member_configs['section_label'];
    const sectionCount = _4.get(this.coreq, 'sections.length');

    return sectionCount === 1 ? `${sectionLabelPrefix} ${_4.get(_4.first(this.coreq.sections), 'cd')}` : '';
  }

  configureAddCourseButton() {
    if (
      this.coreqStatus === ScheduledSectionStatus.CONFLICTING ||
      this.coreqStatus === ScheduledSectionStatus.REGISTERED ||
      this.coreqStatus === ScheduledSectionStatus.SECTION_PICKED
    ) {
      this.addCourseButtonConfig = SectionAddCoreqButtonStrategy[this.coreqStatus];
    } else {
      this.addCourseButtonConfig = SectionAddCoreqButtonStrategy[this.type.toUpperCase()];
    }
  }

  $onChanges(changes: { course: ITermCourse; coreq: ITermCourse }) {
    this.initialize();
  }

  openCoReqDetails() {
    this.ngCourseDetailsFacade.openCourseDetails(this.coreq.nk);
  }

  addButtonPress() {
    if (this.type === 'course') {
      this.addCourseToTerm();
    } else if (this.type === SectionRequisites.ONE_TO_ONE) {
      this.addSectionToTerm();
    } else if (this.type === SectionRequisites.ONE_TO_MANY) {
      this.closeCourseDetailModal();
      this.$state.go(`my.schedule.registration.sectionCoreqs.sections`, {
        courseId: this.coreq.id,
        sectionTypeId: 0
      });
    }
  }

  addSectionToTerm() {
    const section = _4.first(this.coreq.sections);
    const sectionId = _4.get(section, 'id');
    this.ngScheduleSectionFacade.scheduleSection(section as ISection, false).then(() => {
      if (!this.ngCourseDetailsQuery.result) {
        return;
      }
      this.getCrossCourseLinkedSectionsCommand(this.ngCourseDetailsQuery.result.sectionUsedToFetchCourseDetails, true);
    });
  }

  closeCourseDetailModal() {
    this.ngComponentCommunicatorService.publish('CLOSE_COURSE_DETAIL_MODAL');
  }

  addCourseToTerm() {
    const slotId = _4.get(this.course, '_planned_course.program_slot');
    this.saveCoReqCourseToTermCommand(this.coreq.id, this.term.id, slotId).then(() => {
      this.ngRegistrationAlertsServant.showAddedCoreqAlerts(this.coreq);
      this.getTermCoursesCommand(this.term.id).then(() => {
        this.resetCoreqSectionsMetasourceCommand(this.course.id);
        this.QueryMediator.runQueries(this.ngCourseDetailsModel);
      });
    });
  }
}
class CoRequisiteLinkComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      coreq: '<',
      course: '<',
      hideControls: '<',
      isPlanned: '<',
      coreqStatus: '@',
      type: '@'
    };
    this.controller = CoRequisiteLink;
    this.templateUrl =
      'capability-ng-scheduler/src/views/course_details/components/co_requisite_link/co_requisite_link.html';
  }
}
angular.module('capability-ng-scheduler').component('coRequisiteLink', new CoRequisiteLinkComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_details/components/co_requisite_link/co_requisite_link.ts